import { render } from "./AgentHome.vue?vue&type=template&id=05c47f38&scoped=true"
import script from "./AgentHome.vue?vue&type=script&lang=js"
export * from "./AgentHome.vue?vue&type=script&lang=js"

import "./AgentHome.vue?vue&type=style&index=0&id=05c47f38&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05c47f38"]])

export default __exports__